import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export const enrichAccountInformation = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string | undefined,
    authenticationData: AuthenticationData,
    payoutAccountNumber: string,
): Promise<void> => {
    await apiClient<void>(`${proxyBaseUrl}/application/${arn}/enrichAccountInformation`, {
        method: 'PATCH',
        body: { payoutAccountNumber },
        apiKey,
        authenticationData,
        responseType: 'void',
        sentryTag: 'enrich_account_information',
        sentryExtra: { arn },
    });
};
